import { createSlice } from '@reduxjs/toolkit';

type State = { notEmpty: boolean | undefined | null }

const initialState: State = { notEmpty: undefined };

const emptyStateSlice = createSlice({
  name: 'emptyState',
  initialState,
  reducers: {
    updateEmptyState(state: State, action: { payload: boolean }) {
      state.notEmpty = action.payload;
    },
  },
});

export const { updateEmptyState } = emptyStateSlice.actions;

export default emptyStateSlice.reducer;
